import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import storage from '@/store/storage.js'
import moment from 'moment-timezone'

Vue.use(VueI18n)

const messages = require('@/assets/json/messages.json')

Object.assign(messages.en, enLocale)
Object.assign(messages.ja, jaLocale)

const DEFAULT_LANGUAGE = 'en'

const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages,
})

export {
  i18n,
  DEFAULT_LANGUAGE,
}

const setDefaultLocale = () => {
  const currentLang = storage.getItem('language')
  if (currentLang) {
    i18n.locale = currentLang
  } else {
    const locale = (window.navigator.languages && window.navigator.languages[0]) ||
          window.navigator.language ||
          window.navigator.userLanguage ||
          window.navigator.browserLanguage
    i18n.locale = locale.substr(0, 2)
  }
  const tz = moment.tz.guess()
  moment.tz.setDefault(tz)
}

const setMessage = (locale, newMessage) => {
  if (!newMessage || !newMessage.message) return
  const messages = i18n.messages[locale]
  if (messages) {
    Object.assign(messages.message, newMessage.message)
    i18n.setLocaleMessage(locale, messages)
  } else {
    let el
    try {
      el = require('element-ui/lib/locale/lang/' + locale)
    } catch (e) {
      el = require('element-ui/lib/locale/lang/en')
    }
    Object.assign(newMessage, el.default)
    i18n.setLocaleMessage(locale, newMessage)
  }
}

export default {
  setMessage,
  setDefaultLocale,
}